import { api } from "./client";
import type { AuthResponse, LoginRequest, RegisterRequest, SocialLoginRequest, User, UserStats } from "@/types";

export const authApi = {
  login(data: LoginRequest) {
    return api.post<AuthResponse>("/auth/login", data);
  },

  register(data: RegisterRequest) {
    return api.post<AuthResponse>("/auth/register", data);
  },

  socialLogin(data: SocialLoginRequest) {
    return api.post<AuthResponse>("/auth/social-login", data);
  },

  getMe() {
    return api.get<User>("/auth/me");
  },

  updateProfile(data: { first_name?: string; last_name?: string; email?: string }) {
    return api.patch<User>("/auth/me", data);
  },

  getStats() {
    return api.get<UserStats>("/users/me/stats");
  },

  refreshToken(refreshToken: string) {
    return api.post<AuthResponse>("/auth/refresh", { refresh_token: refreshToken });
  },
};
